
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavyRainShowersPolartwilight as ObiLightningHeavyRainShowersPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-rain-showers-polartwilight.js';
 
 
 

 
 export const ObiLightningHeavyRainShowersPolartwilight = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-rain-showers-polartwilight',
   elementClass: ObiLightningHeavyRainShowersPolartwilightElement,
   events: {
     
   }
  });
 
 